import { useSelector } from 'react-redux';
import { ChevronLeftIcon } from '../../components/ui/icons';
import { ListingHeaderActions } from '../../components/features/listings/ListingHeaderActions';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './desktopStickyHeader.styles';

type DesktopStickyHeaderProps = {
  backHref: string;
  onBackClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  backLabel?: string;
};

export const DesktopStickyHeader = ({ backHref, onBackClick, backLabel }: DesktopStickyHeaderProps) => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const listingName =
    (listing as unknown as { propertyName?: string })?.propertyName ||
    (listing as unknown as { displayName?: string })?.displayName ||
    listing?.address?.street ||
    '';

  const label = backLabel ?? 'Back to search';
  const ariaLabel = backLabel ?? 'Back to search results';

  return (
    <header className={styles.desktopHeader}>
      <div className={styles.desktopHeaderColumns}>
        <div className={styles.desktopHeaderLeft}>
          <a href={backHref} onClick={onBackClick} className={styles.backButton} aria-label={ariaLabel}>
            <ChevronLeftIcon />
            <span>{label}</span>
          </a>
        </div>

        <div className={styles.desktopHeaderCenter}>
          <h2 className={styles.listingName}>{listingName}</h2>
        </div>

        <div className={styles.desktopHeaderRight}>
          <ListingHeaderActions size="sm" showCTAs />
        </div>
      </div>
    </header>
  );
};
